module.exports = __webpack_public_path__ + "img/wish-background.75d2ebc5.webp";